import { createDiv, createDom, makeClickable, removeDom } from "../domUtils.mjs";
import createError from "./createError.mjs";
const open = (product) => {
  return new Promise((resolve, reject) => {
    const { price, id } = product;
    const overlay = createDiv("devkit-instant-mock-overlay");
    const container = createDiv(
      "devkit-instant-mock-purchase-confirmation",
      overlay
    );
    const box = createDiv(
      "devkit-instant-mock-purchase-confirmation-box",
      container
    );
    const closeButton = createDiv("devkit-instant-mock-closeBtn", box);
    createDom("h1", null, box).innerText = "Confirm your purchase of " + id;
    createDom("h2", null, box).innerText = price;
    const button = createDiv(
      "devkit-instant-mock-purchase-confirmation-btn",
      box
    );
    button.innerText = "Confirm";
    makeClickable(closeButton, () => {
      removeDom(overlay);
      reject(createError("USER_INPUT"));
    });
    makeClickable(button, () => {
      removeDom(overlay);
      resolve();
    });
  });
};
const purchaseConfirmation = { open };
export {
  purchaseConfirmation as default
};
